import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import { Button, TextField, Card, CardContent, Typography, Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, CircularProgress, Alert } from "@mui/material";

import "./DeheusForm.css";
import logo from '../../assets/deheus1.svg';
import FooterForm from "./FooterForm";
import { validateUserLocation } from '../../tools/geolocationValidator';

function SuccessScreen() {
    return (
        <Box className="container-sucess">
            <Card className="form-card">
                <CardContent>
                    <Typography variant="h4" textAlign="center" color="success.main">✅ Cadastro realizado com sucesso!</Typography>
                    <Typography variant="body1" textAlign="center" mt={2}>Aguarde na sala de motorista a sua liberação.</Typography>
                </CardContent>
            </Card>
        </Box>
    );
}

export default function DeheusForm() {
    const { register, handleSubmit, reset, control } = useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();

    const sanitizeCPF = (cpf) => cpf.replace(/[^\d]/g, "");
    const sanitizePhone = (phone) => phone.replace(/[^\d]/g, "");
    const sanitizePlate = (plate) => plate.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    const onSubmit = async (data) => {
        setLoading(true);
        setErrorMessage("");
        setIsSuccess(false);

        // Sanitiza os dados antes de enviar
        const payload = {
            ...data,
            cpf: sanitizeCPF(data.cpf),
            phone: sanitizePhone(data.phone),
            plate: sanitizePlate(data.plate)
        };

        try {

            const allowedLocations = [
                { lat: -22.3351, lng: -47.5444, name: 'De Heus' },
                { lat: -22.8431, lng: -47.1197, name: 'Home Roger' },
                { lat: -22.9259, lng: -47.0688, name: 'Route Security' }
            ];

            let isNearAny = false;

            for (const loc of allowedLocations) {
                const isNear = await validateUserLocation(loc.lat, loc.lng, 150);
                if (isNear) {
                    isNearAny = true;
                    break; // Sai do loop se encontrar um local válido
                }
            }

            if (!isNearAny) {
                navigate('/location-error');
                return;
            }

            try {
                const response = await fetch("https://api.deheus.yorbit.com.br/oapi/yOrForm", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });

                if (response.status === 200) {
                    setIsSuccess(true);
                    reset();
                } else {
                    const result = await response.json();
                    window.alert(result.error || "Erro ao cadastrar");
                    setErrorMessage(result.error || "Erro ao cadastrar");
                }
            } catch (error) {
                window.alert("Erro ao conectar com o servidor, verifique sua conexão de internet.");
                setErrorMessage("Erro ao conectar com o servidor, verifique sua conexão de internet.");
            }
        } catch (error) {
            alert(error); // Exibe mensagens de erro amigáveis
        }

        setLoading(false);
    };

    if (isSuccess) {
        return <SuccessScreen />;
    }

    return (
        <Box className="container">
            <Card className="form-card">
                <CardContent>
                    <Box display="flex" justifyContent="center" mb={2}>
                        <img src={logo} alt="Logo" className="logo" />
                    </Box>

                    <Typography variant="h5" className="title" ml={1}>
                        Bem Vindo a Portaria De Heus
                    </Typography>

                    {errorMessage && (
                        <Alert severity="error" sx={{ mt: 2 }}>{errorMessage}</Alert>
                    )}

                    <form onSubmit={handleSubmit(onSubmit)} className="form">
                        <Box mb={2} />

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Qual operação veio realizar?</FormLabel>
                            <Controller
                                name="operation"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="carregamento" control={<Radio />} label="Carregamento" />
                                        <FormControlLabel value="descarregamento" control={<Radio />} label="Descarregamento" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Qual unidade De Heus você se encontra?</FormLabel>
                            <Controller
                                name="unit"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="b2782350-0655-11f0-b6fa-9f7aebdea2ec" control={<Radio />} label="Unidade 01 (Av. Brasil, 6624)" />
                                        <FormControlLabel value="813c4ab0-065e-11f0-a3b6-4dae11bd9299" control={<Radio />} label="Unidade 02 (Av. Brasil, 1590)" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                        <p>IMPORTANTE. Caso a resposta seja SIM, o primeiro carregamento deve ocorrer na unidade 2 (Av. Brasil, 1590).</p>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Vai carregar nas duas unidades?</FormLabel>
                            <Controller
                                name="to_load"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>


                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">O caminhão já está carregado?</FormLabel>
                            <Controller
                                name="loaded"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                        <FormControlLabel value="nao" control={<Radio />} label="Não" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>


                        <TextField label="Nome Completo" {...register("name")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="CPF" {...register("cpf")} required fullWidth margin="dense" variant="outlined" inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} />
                        <TextField label="Telefone" {...register("phone")} required fullWidth margin="dense" variant="outlined" inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }} />

                        <p>IMPORTANTE. Caso você seja um autonomo, informe com a palavra Autonomo no campo Transportadora.</p>

                        <TextField label="Transportadora" {...register("carrier")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Tipo Veículo: Ex. Truck. Bitruck. Carreta..." {...register("vehicle")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Placa do Veiculo" {...register("plate")} required fullWidth margin="dense" variant="outlined" />
                        <TextField label="Numero da CG ou NOTA FISCAL" {...register("note_provider")} fullWidth margin="dense" variant="outlined" />

                        <p>IMPORTANTE: Caso não possua um ou mais EPIs obrigatórios para acessar a unidade, seu acesso não estará autorizado.
                            Se isso ocorrer, favor procurar pela transportadora que o contratou ou o departamento de Logística da De Heus.</p>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Possui capacete de segurança?</FormLabel>
                            <RadioGroup row {...register("epi_helmet")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Possui colete refletivo?</FormLabel>
                            <RadioGroup row {...register("epi_vest")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>

                        <FormControl component="fieldset" margin="dense" className="epi-group">
                            <FormLabel component="legend">Possui calçado fechado?</FormLabel>
                            <RadioGroup row {...register("epi_boot")}>
                                <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                                <FormControlLabel value="nao" control={<Radio />} label="Não" />
                            </RadioGroup>
                        </FormControl>
                        {/* <TextField label="Informações adicionais" {...register("others")} fullWidth margin="dense" variant="outlined" /> */}

                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading} sx={{ mt: 2 }}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : "Cadastrar"}
                        </Button>
                    </form>
                </CardContent>
            </Card>
            <FooterForm />
        </Box>
    );
}